export default __webpack_public_path__ + "static/man-98417daf37f7ad54837225d91bc823d2.webp";